import React from 'react';
import { DesignContextForwardProvider, useDesignContext } from '@klarna/designtokens';
import { defaultComponentTokens } from '../defaultComponentTokens';
import { mapTypographyElement } from '../utils';
var SlotBottom = _ref => {
  var {
    children
  } = _ref;
  var designContext = useDesignContext(defaultComponentTokens);
  return /*#__PURE__*/React.createElement(DesignContextForwardProvider, {
    context: designContext
  }, React.Children.map(children, child => mapTypographyElement(child, 'item-information/slot-bottom-text-style', 'item-information/slot-bottom-text-color')));
};
SlotBottom.displayName = 'ItemInformation.SlotBottom';
export { SlotBottom };
//# sourceMappingURL=SlotBottom.js.map